<template>
  <tr>
    <td>
      {{ api.name }}
    </td>
    <td>
      {{ formatedDate }}
    </td>
    <td v-if="!isRevoked">
      <ApisViewModal :api="api" />

      <v-icon size="20"
              slot="activator"
              v-tooltip="$t('message.api.message.revoke')"
              @click="showRevokeModal">mdi-delete</v-icon>
    </td>
    <td v-else>
      {{ api.clientId }}
    </td>

    <app-confirmation-modal :value="showingRevokeModal"
                            :confirm-label="$t('message.api.message.revoke')"
                            @confirm="revokeApi"
                            @cancel="showingRevokeModal = false">
      <span slot="heading">
        {{$t('message.api.message.revokeApi')}}
      </span>
      <span>
        {{$t('message.api.message.revokeApiConfirmation')}}
      </span>
    </app-confirmation-modal>
  </tr>
</template>

<script>
    import moment from 'moment'
    import AppConfirmationModal from '@components/ConfirmationModal'
    import ApisViewModal from '@views/apis/components/ApisViewModal';
    import EventBus from '@packages/event-bus'


    export default {
        components: {
            AppConfirmationModal,
            ApisViewModal
        },

        props: {
            api: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
              showingRevokeModal: false,
            }
        },

        computed: {
          formatedDate() {
            const date = this.isRevoked ? this.api.revocationDate : this.api.creationDate;
            return moment(date).format('L');
          },
          isRevoked() {
            return !!this.api.revocationDate;
          }
        },

        methods:{
            showRevokeModal() {
              this.showingRevokeModal = true;
            },
            remove() {
            },

            async revokeApi() {
              try {
                await this.$api.apis.revoke({
                  apiId: this.api.id
                });

                EventBus.$emit('show-message', {
                  type: 'SUCCESS',
                  message: this.$t('message.successMessages.message.apiRevoked')
                });

                this.showingRevokeModal = false;

                this.$emit('revoked', this.api.clientId);
              } catch (error) {
                console.log(error);
              }
            },
        }        
    }
</script>

<style lang="scss" scoped>
@import "~@variables";

.edit {
  .mdi {
    font-size: 18px;

    &:not(:last-child) {
      margin-right: 6px;
    }
  }
}

.icon-green {
  color: $primary;
}
</style>
